import { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { StatusService } from '../../services/StatusService';

import Toast from "../../helpers/Toast";
import { GetStatusWithNameDTO } from '../../models/Status/GetStatusWithNameDTO';
import { StatusEditProps } from '../../models/Status/StatusProps';
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";

import { Col } from 'reactstrap';
import Layout from '../../components/Layout/Layout';
import PageTitle from '../../components/Layout/PageTitle';


export default function StatusEdit({ setPageTitle }: StatusEditProps) {
    const { id } = useParams<{ id: string }>();
    const intl = useIntl();

    const [status, setStatus] = useState<GetStatusWithNameDTO>({} as GetStatusWithNameDTO);

    const statusService = new StatusService();

    const getStatusById = async () => {
        var response = await statusService.GetStatusById(String(id));

        if (response.success === false || response.obj == null) {
            Toast.Show("error", response.message);
            return;
        }

        setStatus(response.obj);
    };

    useEffect(() => {
        if (id !== '' || id !== null || id != undefined) {
            getStatusById();
        }
    }, []);

    useEffect(() => {
        if(status?.id !== undefined){
            setPageTitle(`Estado ${status?.name}`);
        }
    }, [status?.name]);


    console.log(status);




    return(
        <>
              <Col
              xl={5}
              lg={6}
              md={7}
              sm={10}
              xs={12}
              >
              {/* <TableComponent
                      goToPage={goToPage}
                      loading={loading}
                      pageCount={pageCount}
                      columns={columns}
                      manualPagination={true}
                      fetchData={fetchData}
                      pageSizes={pageSizes}
                      initialPage={page}
                      initialPageSize={pageSize}
                      initialSortBy={initialSortBy}
                      data={status}
                      dontOrderFirstCollumn={true}
                  /> */}
              </Col>
        </>
    );
}